import { render, staticRenderFns } from "./register-phone.vue?vue&type=template&id=3519dc15&scoped=true"
import script from "./register-phone.vue?vue&type=script&lang=js"
export * from "./register-phone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3519dc15",
  null
  
)

export default component.exports